import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';
import vibrating_phone_L from '../assets/vibrating_phone_L.png';
import vibrating_phone_R from '../assets/vibrating_phone_R.png';
import eoy2024Thumbnail from '../assets/thumbnails/eoy_2024_thumbnail.png';
import novFriendsThumbnail from '../assets/thumbnails/nov_friends_2025_thumbnail.png';
import kruzThumbnail from '../assets/thumbnails/kruz_two_footed_thumbnail.png';
import ntsTrenchThumbnail from '../assets/thumbnails/nts_trench_thumbnail.png';
import ProgressIndicator from '../components/ProgressIndicator';
import vaultEvents from '../data/vaultEvents';
import { getFirestore } from "firebase/firestore";
import { collection, addDoc } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import emailjs from '@emailjs/browser';

import novpt2 from '../assets/thumbnails/novpt2.png';
import dmmnts from '../assets/thumbnails/dmmnts_2.png';
import logansama from '../assets/thumbnails/logansama.png';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBpFf41D4-19_S0PptHzqtsdUel6zT8cFA",
  authDomain: "travspresents-f3c23.firebaseapp.com",
  projectId: "travspresents-f3c23",
  storageBucket: "travspresents-f3c23.appspot.com",
  messagingSenderId: "604695859481",
  appId: "1:604695859481:web:ab0229207a7f1fdd2ff588",
  measurementId: "G-0BSD48SDNY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const Home = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isValid, setIsValid] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [activeStep, setActiveStep] = useState(1); // Start with step 1 active
  const [inputFocused, setInputFocused] = useState(false); // Add new state for focus
  const [hoveredSetIndex, setHoveredSetIndex] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [showSmsAlerts, setShowSmsAlerts] = useState(true);
  
  // SMS alerts specific state
  const [smsPhoneNumber, setSmsPhoneNumber] = useState('');
  const [smsSubmitted, setSmsSubmitted] = useState(false);
  const smsAlertsRef = useRef(null);
  
  // Add new state for carousel scroll
  const carouselRef = React.useRef(null);

  const [isPhoneValid, setIsPhoneValid] = useState(false);

  const [contactForm, setContactForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });
  const [contactSubmitted, setContactSubmitted] = useState(false);
  const [contactError, setContactError] = useState(null);

  // Reset showSmsAlerts when component mounts
  useEffect(() => {
    setShowSmsAlerts(true);
  }, []);

  const validatePhoneNumber = (value) => {
    // First regex pattern: International format with dot separator
    const regex1 = /^\+[0-9]{1,3}\.[0-9]{4,14}(?:x.+)?$/;
    
    // Second regex pattern: International format with optional spaces
    const regex2 = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    
    // Also accept UK mobile numbers (starting with 07)
    const ukMobileRegex = /^07[0-9]{9}$/;
    
    return regex1.test(value) || regex2.test(value) || ukMobileRegex.test(value);
  };

  // Update active step based on input length and validation
  useEffect(() => {
    if (phoneNumber.length === 0) {
      setActiveStep(1); // Only first circle filled when empty
    } else if (phoneNumber.length > 0 && phoneNumber.length < 5) {
      setActiveStep(1); // Only first circle filled for 1-4 characters
    } else if (phoneNumber.length >= 5 && phoneNumber.length < 10) {
      setActiveStep(2); // First and second circles filled for 5-9 characters
    } else if (phoneNumber.length >= 10) {
      setActiveStep(3); // All three circles filled for 10+ characters
    }
    
    // Override based on validation and submission
    if (submitted) {
      setActiveStep(3); // All filled when submitted
    }
  }, [phoneNumber, isValid, submitted]);

  // Calculate progress based on phone number length
  const calculateProgress = () => {
    const length = phoneNumber.replace(/\D/g, '').length;
    if (length === 0) return 0;
    if (length < 4) return 1;
    if (length < 10) return 2;
    return 3;
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);
    
    if (value.length > 0) {
      setIsValid(validatePhoneNumber(value));
    } else {
      setIsValid(null);
    }
    
    if (submitted) {
      setSubmitted(false);
    }
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValid) {
      console.log('Submitting phone number:', phoneNumber);
      setSubmitted(true);
    }
  };

  const handleSetImageMouseEnter = (index) => {
    setHoveredSetIndex(index);
  };

  const handleSetImageMouseLeave = () => {
    setHoveredSetIndex(null);
  };

  // Add carousel scroll functions
  const scrollCarousel = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = carouselRef.current.clientWidth * 0.8;
      if (direction === 'left') {
        carouselRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        carouselRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  };

  // Animation handler for phone shake
  const handlePhoneShake = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
    }, 2000);
  };

  // SMS alerts handling
  const handleSmsPhoneChange = (e) => {
    const value = e.target.value;
    setSmsPhoneNumber(value);
    setIsPhoneValid(checkNumber(value));
  };

  const checkNumber = (inputtxt) => {
    const patterns = [
      /^\+([0-9]{2})\)?[-. ]?([0-9]{5})[-. ]?([0-9]{6})$/,  // +XX XXXXX XXXXXX
      /^\d{11}$/,  // 11 digits
      /^\0([0-9]{6})[-. ]?([0-9]{5})$/,  // 0XXXXXX XXXXX
      /^\+([0-9]{2})\)?[-. ]?([0-9]{5})[-. ]?([0-9]{5})$/,   // +XX XXXXX XXXXX
      /^\+1[0-9]{10}$/,  // US format with +1
      /^1[0-9]{10}$/,    // US format with 1
      /^[0-9]{10}$/,     // US format without country code
      /^\([0-9]{3}\)[0-9]{3}-[0-9]{4}$/,  // (XXX)XXX-XXXX
      /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/      // XXX-XXX-XXXX
    ];

    if (inputtxt && inputtxt !== '') {
      return patterns.some(pattern => String(inputtxt).match(pattern));
    }
    return false;
  };

  const handleSmsSubscribe = async (e) => {
    if (e) e.preventDefault();
    
    if (checkNumber(smsPhoneNumber)) {
      try {
        await addDoc(collection(db, "phone-numbers"), {
          phoneNumber: smsPhoneNumber,
          timestamp: new Date()
        });
        setSmsSubmitted(true);
        handlePhoneShake();
      } catch (error) {
        console.error("Error adding phone number:", error);
        setSmsSubmitted(false);
      }
    } else {
      setSmsSubmitted(false);
      // You might want to show an error message here
    }
  };

  const handleSmsClose = () => {
    setShowSmsAlerts(false);
  };

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactError(null);

    // Basic validation
    if (!contactForm.firstName || !contactForm.email || !contactForm.message) {
      setContactError('Please fill in all required fields');
      return;
    }

    try {
      // First, store in Firebase
      await addDoc(collection(db, "contact-messages"), {
        ...contactForm,
        timestamp: new Date()
      });

      // Then send email using EmailJS
      const templateParams = {
        to_email: 'contact@travspresents.tv',
        from_name: `${contactForm.firstName} ${contactForm.lastName}`,
        from_email: contactForm.email,
        phone: contactForm.phone,
        message: contactForm.message
      };

      await emailjs.send(
        'service_7azmxub',
        'template_0yhursg',
        templateParams,
        'clRRNNd3REPot0LYV'
      );
      
      setContactSubmitted(true);
      setContactForm({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
      });

      // Reset form after 3 seconds
      setTimeout(() => {
        setContactSubmitted(false);
      }, 3000);
    } catch (error) {
      console.error("Error submitting contact form:", error);
      setContactError('Failed to send message. Please try again.');
    }
  };

  return (
    <div className="page-container">
      {/* SMS Alerts Box */}
      {showSmsAlerts && (
        <div 
          className="sms-alerts-container"
          ref={smsAlertsRef}
        >
        <div className="sms-content">
            <div className="sms-box">
              <div className="sms-box-inner">
                <div className="sms-left">
                  <img src={vibrating_phone_L} alt="SMS alerts" className="sms-phone-icon" />
          </div>
                <div className="sms-main">
                  <div className="sms-header">
                    <h2 className="sms-title">SMS Alerts</h2>
                    <button className="sms-close-button" style={{display: 'none'}} onClick={handleSmsClose}>&times;</button>
              </div>
                  <div className="sms-text-content">
                    <p className="sms-description">Never miss a show. Show alerts straight to your phone. No spam.</p>
                    {!smsSubmitted ? (
                      <form className="sms-form" onSubmit={handleSmsSubscribe}>
                        <div className="sms-input-container">
                  <input 
                    type="tel"
                    className="sms-phone-input"
                    placeholder="ENTER YOUR NUMBER HERE" 
                    value={smsPhoneNumber}
                    onChange={handleSmsPhoneChange}
                    required
                    style={{
                      borderBottom: isPhoneValid ? '2px solid #4CAF50' : '2px solid #ff3b30',
                      transition: 'border-bottom 0.3s ease'
                    }}
                  />
                          <button 
                            type="submit" 
                            className="subscribe-button"
                            style={{
                              opacity: isPhoneValid ? 1 : 0.5,
                              transition: 'opacity 0.3s ease'
                            }}
                          >
                            SUBSCRIBE
                          </button>
                        </div>
                      </form>
                    ) : (
                      <div className="submission-message">
                        Thanks! You're now subscribed for SMS alerts.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* SMS Open Button */}
      {!showSmsAlerts && (
        <button 
          className="open-sms-button"
          onClick={() => setShowSmsAlerts(true)}
        >
          Get SMS Alerts
        </button>
      )}
      <div className="recent-sets-container">
        <h2 className="recent-sets-title">RECENT SETS</h2>
        <div className={`sets-grid ${hoveredSetIndex !== null ? 'hovering-image' : ''}`}>
          <div className={`set-item ${hoveredSetIndex === 0 ? 'hovered-item' : ''}`}>
            <a 
              href="https://www.youtube.com/watch?v=QilNfwkoAvY"
              target="_blank"
              rel="noopener noreferrer"
              className="set-image-wrapper"
              onMouseEnter={() => handleSetImageMouseEnter(0)}
              onMouseLeave={handleSetImageMouseLeave}
            >
              <img src={novpt2} alt="Novelist + Friends Part 2" className="set-image" />
            </a>
            <div className="set-info">
              <h3 className="set-title">Novelist + Friends Part 2</h3>
              <p className="set-artists">Novelist, Jme, Renz, So Large, Mimi Mxnroe, Shorty, C4, Mez, Shorty, Jammin, Manga Saint Hilare, Tamakloe, £Monzo, Kruz Leone, Lioness, Cannon + Dee Santino</p>
            </div>
          </div>
          <div className={`set-item ${hoveredSetIndex === 1 ? 'hovered-item' : ''}`}>
            <a 
              href="https://www.youtube.com/watch?v=hlQDBMcZdyY"
              target="_blank"
              rel="noopener noreferrer"
              className="set-image-wrapper"
              onMouseEnter={() => handleSetImageMouseEnter(1)}
              onMouseLeave={handleSetImageMouseLeave}
            >
              <img src={dmmnts} alt="DaMetalMessiah + Friends" className="set-image" />
            </a>
            <div className="set-info">
              <h3 className="set-title">DaMetalMessiah + Friends</h3>
              <p className="set-artists">Kibo, Jafro, Trilla, Merky Ace, Trappy, JayaHadADream, Lady Ice, Micofcourse, Mr Manage, M.I.C, Crafty893, Blessed, N3, twenty8, Jawnino, Duppy</p>
            </div>
          </div>
          <div className={`set-item ${hoveredSetIndex === 2 ? 'hovered-item' : ''}`}>
            <a 
              href="https://www.youtube.com/watch?v=ZKJJgnxE9lc"
              target="_blank"
              rel="noopener noreferrer"
              className="set-image-wrapper"
              onMouseEnter={() => handleSetImageMouseEnter(2)}
              onMouseLeave={handleSetImageMouseLeave}
            >
              <img src={logansama} alt="Merky Ace, Faultsz, Elf, Mez, Logan Sama + More!" className="set-image" />
            </a>
            <div className="set-info">
              <h3 className="set-title">Pop-up with Logan Sama</h3>
              <p className="set-artists">Mez, N3, Merky Ace, Logan, M.I.C, Sbk, Renz, Spitz, Faultsz, Elf, Fusion, Amzzino, Babydoom, Essem</p>
            </div>
          </div>
          <div className={`set-item ${hoveredSetIndex === 3 ? 'hovered-item' : ''}`}>
            <a 
              href="https://www.youtube.com/watch?v=4RE6lIlGr-k"
              target="_blank"
              rel="noopener noreferrer"
              className="set-image-wrapper"
              onMouseEnter={() => handleSetImageMouseEnter(3)}
              onMouseLeave={handleSetImageMouseLeave}
            >
              <img src={ntsTrenchThumbnail} alt="NTS: 7 Years of Trench" className="set-image" />
            </a>
            <div className="set-info">
              <h3 className="set-title">NTS: 7 Years of Trench</h3>
              <p className="set-artists">Flirta D, Mez, JayaHadADream, Manga Saint Hilare, Shakes + More</p>
            </div>
          </div>
        </div>
        <div className="sets-container">
          <a 
            href="https://www.youtube.com/@travspresents" 
            className="view-more-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            VIEW OUR OTHER SETS HERE
          </a>
        </div>
      </div>
      <div className="store-preview-container">
        <h2 className="store-title">STORE</h2>
        <div className="store-grid">
          <Link to="/store/kurupt-tee">
          <div className="store-item kurupt-tee-item">
            <div className="store-image-container">
              <img src={require('../assets/store/KURUPT TEE.png')} alt="Kurupt Tee" className="store-image kurupt-front" />
              <img src={require('../assets/store/KURUPT TEE BACK.png')} alt="Kurupt Tee Back" className="store-image kurupt-back" />
            </div>
            <div className="store-info">
              <p className="store-item-subtitle" style={{color: 'green'}}>NEW!</p>
              <h3 className="store-item-title">Kurupt FM Heavy Tee</h3>
              <p className="store-item-price">£35</p>
            </div>
          </div>
          </Link>
          <Link to="/store/satellite-tee">
          <div className="store-item">
            <div className="store-image-container">
              <img src={require('../assets/store/SATELLITE TEE FRONT.png')} alt="Satellite Tee" className="store-image" />
            </div>
            <div className="store-info">
              <p className="store-item-subtitle" style={{color: 'green'}}>NEW!</p>
              <h3 className="store-item-title">Satellite Heavy Tee</h3>
              <p className="store-item-price">£30</p>
            </div>
          </div>
          </Link>
          <Link to="/store/og-tee">
          <div className="store-item">
            <div className="store-image-container">
              <img src={require('../assets/store/OG Tee.png')} alt="OG Tee" className="store-image" />
            </div>
            <div className="store-info">
              <p className="store-item-subtitle" style={{color: 'white'}}>NEW!</p>
              <h3 className="store-item-title">OG Heavy Tee</h3>
              <p className="store-item-price">£30</p>
            </div>
          </div>
          </Link>
          <Link to="/store/og-tee">
          <div className="store-item">
            <div className="store-image-container">
              <img src={require('../assets/store/Eyes Tee.png')} alt="Eyes Tee" className="store-image" />
            </div>
            <div className="store-info">
              <p className="store-item-subtitle" style={{color: 'red'}}>NEW!</p>
              <h3 className="store-item-title">Eyes Heavy Tee</h3>
              <p className="store-item-price">£30</p>
            </div>
          </div>
          </Link>
        </div>
      </div>

      <div className="vault-preview-container">
        <h2 className="vault-title">THE VAULT</h2>
        <div className="carousel-container">
          <button className="carousel-arrow left" onClick={() => scrollCarousel('left')}>&#10094;</button>
          <div className="carousel-content" ref={carouselRef}>
            {vaultEvents.map((event) => (
              <Link 
                to={`/vault/${event.id}`} 
                key={event.id} 
                className="carousel-item"
              >
                {(() => {
                  try {
                    const posterImage = require(`../assets/posters/${event.posterImage}`);
                    return (
                      <img 
                        src={posterImage} 
                        alt={event.title} 
                        className="vault-poster" 
                      />
                    );
                  } catch (error) {
                    console.error(`Failed to load poster: ${event.posterImage}`, error);
                    return null;
                  }
                })()}
              </Link>
            ))}
          </div>
          <button className="carousel-arrow right" onClick={() => scrollCarousel('right')}>&#10095;</button>
        </div>
        <div className="vault-button-container">
          <Link to="/the-vault" className="visit-vault-button">VISIT THE SET VAULT</Link>
        </div>
          </div>
          
      <div className="contact-section">
        <h2 className="contact-title">CONTACT US</h2>
        <div className="contact-form-container">
          <form onSubmit={handleContactSubmit}>
            <div className="contact-form-row">
              <input 
                type="text" 
                name="firstName"
                className="contact-input" 
                placeholder="FIRST NAME *" 
                value={contactForm.firstName}
                onChange={handleContactChange}
              />
              <input 
                type="text" 
                name="lastName"
                className="contact-input" 
                placeholder="LAST NAME" 
                value={contactForm.lastName}
                onChange={handleContactChange}
              />
            </div>
            <div className="contact-form-row">
              <input 
                type="email" 
                name="email"
                className="contact-input" 
                placeholder="EMAIL ADDRESS *" 
                value={contactForm.email}
                onChange={handleContactChange}
              />
              <input 
                type="tel" 
                name="phone"
                className="contact-input" 
                placeholder="PHONE NUMBER" 
                value={contactForm.phone}
                onChange={handleContactChange}
              />
            </div>
            <div className="contact-form-row single">
              <textarea 
                name="message"
                className="contact-textarea" 
                placeholder="TYPE YOUR MESSAGE HERE *"
                value={contactForm.message}
                onChange={handleContactChange}
              ></textarea>
            </div>
            {contactError && (
              <div className="contact-error">
                {contactError}
              </div>
            )}
            {contactSubmitted && (
              <div className="contact-success">
                Message sent successfully!
              </div>
            )}
            <div className="contact-form-row">
              <button type="submit" className="contact-submit-button">
                SEND MESSAGE
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Home; 